/*!
 * Tradeshow Floor Plan — embeddable widget
 * Build: 2026-06-12-drag-threshold-v6
 * Usage:
 *   <div data-floor-plan></div>
 *   <script defer></script>
 *
 * Editor mode (drag/resize + export JSON):
 *   <div data-floor-plan data-editable></div>
 *   or append ?fp-edit=1 to the page URL
 *
 * Vendor fields: id, name, booth, category, description, website?, col, row, w?, h?
 */
(function () {
  "use strict";

  var SVG_NS = "http://www.w3.org/2000/svg";
  var COLS = 12;
  var ROWS = 9;
  var CELL = 70;
  var PAD = 35;
  var W = COLS * CELL + PAD * 2;
  var H = ROWS * CELL + PAD * 2;
  var ENTRANCE = { col: Math.ceil(COLS / 2), row: ROWS + 0.5 };

  var DEFAULT_VENDORS = [
    {
      id: "V1",
      name: "Northwind Robotics",
      booth: "4",
      category: "Automation",
      description: "Live demos all weekend.",
      description2: "Live demos all weekend.",
      col: 1,
      row: 6,
      w: 1,
    },
    {
      id: "V2",
      name: "Lumen Optics",
      booth: "1",
      category: "Hardware",
      description: "New products on display.",
      description2: "Live demos all weekend.",
      col: 1,
      row: 10,
      w: 1,
    },
    {
      id: "T52",
      booth: "20",
      name: "New Booth 52",
      category: "Uncategorized",
      description: "Add a short description for this vendor.",
      description2: "Live demos all weekend.",
      col: 12,
      row: 10,
    },
  ];

  var STYLE_ID = "lov-floor-plan-style";
  var CSS = [
    ".lov-fp{font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,sans-serif;color:#0f172a;display:grid;gap:16px;grid-template-columns:1fr;width:100%}",
    "@media(min-width:900px){.lov-fp{grid-template-columns:1fr 340px}}",
    ".lov-fp *{box-sizing:border-box}",
    ".lov-fp-map{background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:12px;overflow:auto;position:relative;-webkit-overflow-scrolling:touch;touch-action:pan-x pan-y;overscroll-behavior:contain}",
    ".lov-fp-map svg{display:block;width:100%;height:auto;touch-action:pan-x pan-y}",
    ".lov-fp-hint{font-size:12px;color:#64748b;margin:0 4px 8px}",
    ".lov-fp-panel{background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:16px;font-size:14px;line-height:1.5;min-height:160px;transition:box-shadow .25s ease,border-color .25s ease}",
    ".lov-fp-panel.is-preview{border-color:#93c5fd;box-shadow:0 6px 24px -8px rgba(37,99,235,.25)}",
    ".lov-fp-panel > *{animation:lovFpPanelIn .28s cubic-bezier(.16,1,.3,1) both}",
    "@keyframes lovFpPanelIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}",
    ".lov-fp-panel h3{margin:0 0 4px;font-size:18px;font-weight:600}",
    ".lov-fp-panel .lov-fp-meta{font-size:12px;color:#64748b;text-transform:uppercase;letter-spacing:.08em;margin-bottom:8px}",
    ".lov-fp-panel a{color:#2563eb;text-decoration:none}",
    ".lov-fp-panel a:hover{text-decoration:underline}",
    ".lov-fp-logo{margin:10px 0;display:flex;align-items:center;justify-content:center;padding:12px;border:1px solid #e5e7eb;border-radius:5px;background:#f8fafc}",
    ".lov-fp-logo img{max-width:100%;max-height:120px;object-fit:contain;display:block}",
    ".lov-fp-share{margin-top:14px;padding:14px 16px;border:1px solid #e5e7eb;border-radius:5px;background:#f8fafc;display:flex;gap:12px;align-items:center;box-shadow:0 1px 2px rgba(15,23,42,.04)}",
    ".lov-fp-share img{width:56px;height:56px;border-radius:0;background:#fff;flex-shrink:0}",
    ".lov-fp-share-body{font-size:12px;color:#475569;min-width:0;flex:1}",
    ".lov-fp-share-body strong{display:block;color:#0f172a;font-size:13px;margin-bottom:4px}",
    ".lov-fp-share-link{display:block;word-break:break-all;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:11px;color:#2563eb;margin-bottom:6px}",
    ".lov-fp-share-btn{background:#0f172a;color:#fff;border:0;border-radius:6px;padding:6px 10px;font-size:12px;cursor:pointer}",
    ".lov-fp-share-btn:hover{background:#1e293b}",
    ".lov-fp-buy{margin-top:10px;padding:14px 16px;border:1px solid #e5e7eb;border-radius:5px;background:#f8fafc;display:flex;gap:12px;align-items:center;justify-content:space-between;box-shadow:0 1px 2px rgba(15,23,42,.04)}",
    ".lov-fp-buy-body{font-size:12px;color:#475569;min-width:0;flex:1}",
    ".lov-fp-buy-body strong{display:block;color:#0f172a;font-size:13px;margin-bottom:2px}",
    ".lov-fp-panel a.lov-fp-buy-btn{background:#0f172a;color:#fff;border:0;border-radius:6px;padding:6px 10px;font-size:12px;cursor:pointer;text-decoration:none;display:inline-block;white-space:nowrap}",
    ".lov-fp-panel a.lov-fp-buy-btn:hover{background:#1e293b;text-decoration:none;color:#fff}",
    ".lov-fp-empty{color:#64748b}",
    ".lov-fp-booth{cursor:pointer;transition:transform .18s cubic-bezier(.16,1,.3,1),filter .18s ease}",
    ".lov-fp-booth:hover{transform:translateY(-2px);filter:drop-shadow(0 6px 10px rgba(37,99,235,.18))}",
    ".lov-fp-booth:hover rect.lov-fp-booth-bg{stroke:#2563eb;stroke-width:2}",
    ".lov-fp-booth.is-selected rect.lov-fp-booth-bg{fill:#dbeafe;stroke:#2563eb;stroke-width:2.5}",
    ".lov-fp-route{stroke:#2563eb;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:2 8;fill:none}",
    ".lov-fp-entrance{fill:#10b981}",
    ".lov-fp-entrance-label{font-size:12px;fill:#065f46;font-weight:600}",
    ".lov-fp-walker{fill:#f59e0b;stroke:#fff;stroke-width:1.5;pointer-events:none}",
    ".lov-fp-walker-head{fill:#fbbf24;stroke:#b45309;stroke-width:.8;pointer-events:none}",
    /* editor */
    ".lov-fp.is-edit .lov-fp-map{touch-action:none}",
    ".lov-fp.is-edit .lov-fp-map svg{touch-action:none}",
    ".lov-fp.is-edit .lov-fp-booth{cursor:grab;touch-action:none}",
    ".lov-fp.is-edit .lov-fp-booth.is-dragging{cursor:grabbing}",
    ".lov-fp-resize{fill:#2563eb;cursor:nwse-resize;touch-action:none}",

    ".lov-fp-toolbar{display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin:0 0 10px;padding:8px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:8px;font-size:13px}",
    ".lov-fp-toolbar button{background:#2563eb;color:#fff;border:0;border-radius:6px;padding:6px 12px;font-size:13px;cursor:pointer;font-weight:500}",
    ".lov-fp-toolbar button.secondary{background:#fff;color:#0f172a;border:1px solid #cbd5e1}",
    ".lov-fp-toolbar button:hover{opacity:.9}",
    ".lov-fp-toolbar .lov-fp-status{color:#64748b;margin-left:auto;font-size:12px}",
    ".lov-fp-export{position:fixed;inset:0;background:rgba(15,23,42,.6);display:flex;align-items:center;justify-content:center;z-index:9999;padding:20px}",
    ".lov-fp-export-card{background:#fff;border-radius:12px;padding:20px;max-width:720px;width:100%;max-height:80vh;display:flex;flex-direction:column;gap:12px}",
    ".lov-fp-export-card h3{margin:0;font-size:18px}",
    ".lov-fp-export-card textarea{flex:1;min-height:300px;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:12px;border:1px solid #cbd5e1;border-radius:6px;padding:10px;resize:vertical}",
    ".lov-fp-export-card .lov-fp-row{display:flex;gap:8px;justify-content:flex-end}",
  ].join("");

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function el(tag, attrs, children) {
    var n = document.createElementNS(SVG_NS, tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (children) for (var i = 0; i < children.length; i++) n.appendChild(children[i]);
    return n;
  }
  function html(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    return n;
  }
  function cellCenter(col, row) {
    return { x: PAD + (col - 0.5) * CELL, y: PAD + (row - 0.5) * CELL };
  }
  function boothBox(v) {
    var col = +v.col,
      row = +v.row;
    var w = Math.max(1, +v.w || 1);
    var h = Math.max(1, +v.h || 1);
    return {
      x: PAD + (col - 1) * CELL + 1,
      y: PAD + (row - 1) * CELL + 1,
      w: w * CELL - 2,
      h: h * CELL - 2,
      cx: PAD + (col - 1 + w / 2) * CELL,
      cy: PAD + (row - 1 + h / 2) * CELL,
    };
  }
  function boothCenter(v) {
    var b = boothBox(v);
    return { x: b.cx, y: b.cy };
  }

  function computePath(vendors, selected) {
    if (!selected) return null;
    var occupied = {};
    var selCol = +selected.col,
      selRow = +selected.row;
    for (var i = 0; i < vendors.length; i++) {
      var v = vendors[i];
      if (v.id === selected.id) continue;
      var vCol = +v.col,
        vRow = +v.row;
      var w = Math.max(1, +v.w || 1),
        h = Math.max(1, +v.h || 1);
      for (var dx = 0; dx < w; dx++)
        for (var dy = 0; dy < h; dy++) {
          occupied[vCol + dx + "," + (vRow + dy)] = true;
        }
    }
    // pick any cell of selected as target (top-left)
    var targetKey = selCol + "," + selRow;
    var start = null;
    for (var d = 0; d < COLS && !start; d++) {
      var cands = [ENTRANCE.col - d, ENTRANCE.col + d];
      for (var j = 0; j < cands.length; j++) {
        var c = cands[j];
        if (c < 1 || c > COLS) continue;
        var k = c + "," + ROWS;
        if (!occupied[k]) {
          start = { col: c, row: ROWS };
          break;
        }
      }
    }
    if (!start) return null;
    var cameFrom = {};
    var startKey = start.col + "," + start.row;
    cameFrom[startKey] = null;
    var queue = [start];
    var dirs = [
      [1, 0],
      [-1, 0],
      [0, 1],
      [0, -1],
    ];
    // also accept arriving at any cell adjacent to the selected booth
    var sw = Math.max(1, +selected.w || 1),
      sh = Math.max(1, +selected.h || 1);
    var targetCells = {};
    for (var tx = 0; tx < sw; tx++)
      for (var ty = 0; ty < sh; ty++) {
        targetCells[selCol + tx + "," + (selRow + ty)] = true;
      }
    var found = null;
    while (queue.length) {
      var cur = queue.shift();
      var curKey = cur.col + "," + cur.row;
      if (targetCells[curKey]) {
        found = curKey;
        break;
      }
      for (var di = 0; di < 4; di++) {
        var nc = cur.col + dirs[di][0];
        var nr = cur.row + dirs[di][1];
        if (nc < 1 || nc > COLS || nr < 1 || nr > ROWS) continue;
        var nk = nc + "," + nr;
        if (nk in cameFrom) continue;
        if (occupied[nk] && !targetCells[nk]) continue;
        cameFrom[nk] = curKey;
        queue.push({ col: nc, row: nr });
      }
    }
    if (!found) return null;
    var cells = [];
    var cur2 = found;
    while (cur2) {
      cells.unshift(cur2);
      cur2 = cameFrom[cur2];
    }
    // Drop trailing cells that fall inside the selected booth so walkers
    // stop at the table edge instead of stepping onto the table itself.
    while (cells.length > 1 && targetCells[cells[cells.length - 1]]) cells.pop();
    var entrancePt = cellCenter(ENTRANCE.col, ENTRANCE.row);
    var pts = [entrancePt];
    for (var ci = 0; ci < cells.length; ci++) {
      var parts = cells[ci].split(",");
      pts.push(cellCenter(+parts[0], +parts[1]));
    }
    // Collision buffer: scales with the current cell size so walkers keep
    // clear of every lov-fp-booth-bg rect regardless of booth dimensions
    // or zoom. Tuned to ~18% of a cell with a small absolute floor.
    var BUFFER = Math.max(6, Math.round(CELL * 0.18));

    // Push a point outside a booth rect, padded by BUFFER. If the point is
    // inside (or within BUFFER of) the rect, snap it to the nearest edge
    // along the shorter axis. Returns a new point.
    function pushOutside(p, rect) {
      var minX = rect.x - BUFFER,
        maxX = rect.x + rect.w + BUFFER,
        minY = rect.y - BUFFER,
        maxY = rect.y + rect.h + BUFFER;
      if (p.x <= minX || p.x >= maxX || p.y <= minY || p.y >= maxY) return p;
      var dl = p.x - minX,
        dr = maxX - p.x,
        dt = p.y - minY,
        db = maxY - p.y;
      var m = Math.min(dl, dr, dt, db);
      if (m === dl) return { x: minX, y: p.y };
      if (m === dr) return { x: maxX, y: p.y };
      if (m === dt) return { x: p.x, y: minY };
      return { x: p.x, y: maxY };
    }

    // Final waypoint: nearest point on the selected booth's padded edge.
    var bb = boothBox(selected);
    var approach = pts[pts.length - 1];
    var ex = Math.max(bb.x, Math.min(bb.x + bb.w, approach.x));
    var ey = Math.max(bb.y, Math.min(bb.y + bb.h, approach.y));
    var insideX = ex > bb.x && ex < bb.x + bb.w;
    var insideY = ey > bb.y && ey < bb.y + bb.h;
    if (insideX && insideY) {
      var dl2 = ex - bb.x,
        dr2 = bb.x + bb.w - ex,
        dt2 = ey - bb.y,
        db2 = bb.y + bb.h - ey;
      var m2 = Math.min(dl2, dr2, dt2, db2);
      if (m2 === dl2) ex = bb.x;
      else if (m2 === dr2) ex = bb.x + bb.w;
      else if (m2 === dt2) ey = bb.y;
      else ey = bb.y + bb.h;
    }
    if (ex <= bb.x) ex = bb.x - BUFFER;
    else if (ex >= bb.x + bb.w) ex = bb.x + bb.w + BUFFER;
    if (ey <= bb.y) ey = bb.y - BUFFER;
    else if (ey >= bb.y + bb.h) ey = bb.y + bb.h + BUFFER;
    pts.push({ x: ex, y: ey });

    // Sweep every waypoint against every booth rect so the dotted line and
    // walkers never overlap a booth background, even if booth sizes change.
    var boothRects = [];
    for (var bi = 0; bi < vendors.length; bi++) boothRects.push(boothBox(vendors[bi]));
    for (var pi = 1; pi < pts.length; pi++) {
      var moved = true,
        guard = 0;
      while (moved && guard++ < 4) {
        moved = false;
        for (var ri = 0; ri < boothRects.length; ri++) {
          var np = pushOutside(pts[pi], boothRects[ri]);
          if (np.x !== pts[pi].x || np.y !== pts[pi].y) {
            pts[pi] = np;
            moved = true;
          }
        }
      }
    }

    return pts
      .map(function (p, idx) {
        return (idx === 0 ? "M" : "L") + " " + p.x + " " + p.y;
      })
      .join(" ");
  }

  function render(container, vendors, opts) {
    opts = opts || {};
    var editable = !!opts.editable;
    container.innerHTML = "";
    container.classList.add("lov-fp");
    if (editable) container.classList.add("is-edit");

    var mapWrap = html("div", { class: "lov-fp-map" });

    var statusEl = null;
    if (editable) {
      var bar = html("div", { class: "lov-fp-toolbar" });
      var saveBtn = html("button", null, "Save");
      var printBtn = html("button", { class: "secondary" }, "Print");
      var exportBtn = html("button", { class: "secondary" }, "Export JSON");
      var addBtn = html("button", null, "+ Add booth");
      var removeBtn = html("button", { class: "secondary" }, "Remove selected");
      var regenBtn = html("button", { class: "secondary" }, "Regenerate defaults");
      var resetBtn = html("button", { class: "secondary" }, "Reset");
      statusEl = html("span", { class: "lov-fp-status" }, "Drag booths to move. Drag the blue corner to resize.");
      bar.appendChild(addBtn);
      bar.appendChild(removeBtn);
      bar.appendChild(saveBtn);
      bar.appendChild(printBtn);
      bar.appendChild(exportBtn);
      bar.appendChild(regenBtn);
      bar.appendChild(resetBtn);
      bar.appendChild(statusEl);
      mapWrap.appendChild(bar);
      saveBtn.addEventListener("click", function () {
        try {
          var key = opts.storageKey || "lov-fp:vendors";
          localStorage.setItem(key, JSON.stringify(vendors));
          if (statusEl) statusEl.textContent = "Saved " + vendors.length + " booths to this browser.";
          saveBtn.textContent = "Saved!";
          setTimeout(function () {
            saveBtn.textContent = "Save";
          }, 1500);
        } catch (err) {
          if (statusEl)
            statusEl.textContent = "Save failed: " + (err && err.message ? err.message : "storage unavailable");
        }
      });
      printBtn.addEventListener("click", function () {
        printFloorPlan(svg, opts);
      });
      exportBtn.addEventListener("click", function () {
        showExport(vendors);
      });

      addBtn.addEventListener("click", function () {
        // Find the first empty 1x1 cell.
        var taken = {};
        for (var i = 0; i < vendors.length; i++) {
          var o = vendors[i];
          var ow = Math.max(1, +o.w || 1),
            oh = Math.max(1, +o.h || 1);
          for (var dx = 0; dx < ow; dx++)
            for (var dy = 0; dy < oh; dy++) taken[+o.col + dx + "," + (+o.row + dy)] = true;
        }
        var spot = null;
        for (var r = 1; r <= ROWS && !spot; r++)
          for (var c = 1; c <= COLS && !spot; c++) if (!taken[c + "," + r]) spot = { col: c, row: r };
        if (!spot) {
          if (statusEl) statusEl.textContent = "No empty cell available — resize or remove a booth first.";
          return;
        }
        // Generate a unique id and booth number.
        var maxN = 0;
        for (var k = 0; k < vendors.length; k++) {
          var m = /(\d+)$/.exec(vendors[k].id || "");
          if (m) maxN = Math.max(maxN, +m[1]);
        }
        var n = maxN + 1;
        var nv = {
          id: "T" + n,
          booth: String(n),
          name: "New Booth " + n,
          category: "Uncategorized",
          description: "Add a short description for this vendor.",
          description2: "Add a short description for this vendor.",
          col: spot.col,
          row: spot.row,
          w: 1,
          h: 1,
        };
        vendors.push(nv);
        rebuild();
        select(nv.id);
        if (statusEl) statusEl.textContent = "Added " + nv.id + " at col " + spot.col + ", row " + spot.row + ".";
      });
      removeBtn.addEventListener("click", function () {
        var sel = state.selected;
        if (!sel) {
          if (statusEl) statusEl.textContent = "Select a booth first, then click Remove.";
          return;
        }
        if (!confirm("Remove booth " + (sel.booth || sel.id) + "?")) return;
        for (var i = 0; i < vendors.length; i++) {
          if (vendors[i].id === sel.id) {
            vendors.splice(i, 1);
            break;
          }
        }
        state.selected = null;
        rebuild();
        showEntrance();
        if (statusEl) statusEl.textContent = "Removed " + (sel.booth || sel.id) + ".";
      });
      resetBtn.addEventListener("click", function () {
        if (!confirm("Reset all positions to the originally loaded layout?")) return;
        vendors.length = 0;
        for (var i = 0; i < opts.initial.length; i++) vendors.push(JSON.parse(JSON.stringify(opts.initial[i])));
        rebuild();
      });
      regenBtn.addEventListener("click", function () {
        if (!confirm("Replace all vendors with the built-in defaults? Your current layout will be lost.")) return;
        vendors.length = 0;
        for (var j = 0; j < DEFAULT_VENDORS.length; j++) vendors.push(JSON.parse(JSON.stringify(DEFAULT_VENDORS[j])));
        rebuild();
        if (statusEl) statusEl.textContent = "Loaded " + DEFAULT_VENDORS.length + " default vendors.";
      });
    } else {
      var hintRow = html("div", {
        style: "display:flex;align-items:center;justify-content:space-between;gap:8px;margin:0 4px 8px",
      });
      hintRow.appendChild(
        html(
          "p",
          { class: "lov-fp-hint", style: "margin:0" },
          "Tap a table to view vendor details and route from the entrance.",
        ),
      );
      var viewPrintBtn = html(
        "button",
        {
          type: "button",
          style:
            "background:#0f172a;color:#fff;border:0;border-radius:6px;padding:6px 12px;font-size:12px;cursor:pointer;font-weight:500",
        },
        "Print",
      );
      viewPrintBtn.addEventListener("click", function () {
        printFloorPlan(svg, opts);
      });
      hintRow.appendChild(viewPrintBtn);
      mapWrap.appendChild(hintRow);
    }

    var svg = el("svg", {
      viewBox: "0 0 " + W + " " + H,
      role: "img",
      "aria-label": "Tradeshow floor plan",
      style: "min-width:" + COLS * 56 + "px",
    });
    mapWrap.appendChild(svg);

    var panel = html("aside", { class: "lov-fp-panel" });
    container.appendChild(mapWrap);
    container.appendChild(panel);

    var boothNodes = {};
    var state = { selected: null };
    var routePath;

    function rebuild() {
      svg.innerHTML = "";
      boothNodes = {};

      svg.appendChild(
        el("rect", {
          x: PAD - 16,
          y: PAD - 16,
          width: COLS * CELL + 32,
          height: ROWS * CELL + 32,
          rx: 12,
          fill: "#f1f5f9",
        }),
      );

      if (editable) {
        // grid lines
        for (var gc = 0; gc <= COLS; gc++) {
          svg.appendChild(
            el("line", {
              x1: PAD + gc * CELL,
              y1: PAD,
              x2: PAD + gc * CELL,
              y2: PAD + ROWS * CELL,
              stroke: "#e2e8f0",
              "stroke-width": 1,
            }),
          );
        }
        for (var gr = 0; gr <= ROWS; gr++) {
          svg.appendChild(
            el("line", {
              x1: PAD,
              y1: PAD + gr * CELL,
              x2: PAD + COLS * CELL,
              y2: PAD + gr * CELL,
              stroke: "#e2e8f0",
              "stroke-width": 1,
            }),
          );
        }
      }

      var ent = cellCenter(ENTRANCE.col, ENTRANCE.row);
      svg.appendChild(el("circle", { class: "lov-fp-entrance", cx: ent.x, cy: ent.y, r: 10 }));
      var entLabel = el("text", { class: "lov-fp-entrance-label", x: ent.x, y: ent.y + 26, "text-anchor": "middle" });
      entLabel.textContent = "Entrance";
      svg.appendChild(entLabel);

      // (The four black dots that used to sit near the entrance now walk
      // looping routes alongside the mascots — see startWalkers().)

      // Roytato mascot near the entrance — clickable to show entrance info
      var mascot = el("image", {
        href: "https://cdn.shopify.com/s/files/1/0016/8892/8354/files/roytato-potato.png?v=1781241271",
        x: ent.x + 40,
        y: ent.y - 30,
        width: 60,
        height: 60,
        style: "cursor:pointer",
        role: "button",
        "aria-label": "Show entrance information and directions",
      });
      mascot.addEventListener("click", function () {
        showEntrance();
      });
      svg.appendChild(mascot);

      // Clicking the entrance circle/label also opens the entrance panel
      var entranceHit = el("circle", {
        cx: ent.x,
        cy: ent.y,
        r: 22,
        fill: "transparent",
        style: "cursor:pointer",
        role: "button",
        "aria-label": "Show entrance information",
      });
      entranceHit.addEventListener("click", function () {
        showEntrance();
      });
      svg.appendChild(entranceHit);

      vendors.forEach(function (v) {
        drawBooth(v);
      });

      // Route path appended LAST so the dotted line paints on top of booths
      routePath = el("path", { class: "lov-fp-route", "pointer-events": "none" });
      var anim = el("animate", {
        attributeName: "stroke-dashoffset",
        from: "0",
        to: "-40",
        dur: "1.2s",
        repeatCount: "indefinite",
      });
      routePath.appendChild(anim);
      svg.appendChild(routePath);
      // Walkers layer (animated people walking from entrance to random tables)
      walkersLayer = el("g", { class: "lov-fp-walkers", "pointer-events": "none" });
      svg.appendChild(walkersLayer);
      // Re-apply current selection (e.g. after a rebuild) so the route survives.
      if (state.selected) {
        var dCur = computePath(vendors, state.selected);
        if (dCur) routePath.setAttribute("d", dCur);
      }

      renderEmpty(panel);
      state.selected = null;
      startWalkers();
      // Expose a per-container API for adding custom walkers from host pages.
      container.__lovFpAddWalker = function (o) {
        return spawnWalker("custom", o || {});
      };
    }

    var walkersLayer;
    var walkerTimer;
    var WALKER_COLORS = ["#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4", "#ec4899", "#22c55e"];

    var MASCOT_URL = "https://cdn.shopify.com/s/files/1/0016/8892/8354/files/roytato-potato.png";
    var MASCOT_SIZE = 44;

    // Parse "M x y L x y ..." into a point array.
    function parsePathPoints(d) {
      var tokens = d.split(/\s+/).filter(Boolean);
      var pts = [];
      for (var i = 0; i < tokens.length; i++) {
        if (tokens[i] === "M" || tokens[i] === "L") {
          pts.push([+tokens[i + 1], +tokens[i + 2]]);
          i += 2;
        }
      }
      return pts;
    }

    function pointsToPath(pts) {
      return pts
        .map(function (p, i) {
          return (i === 0 ? "M" : "L") + " " + p[0] + " " + p[1];
        })
        .join(" ");
    }

    function reversePathString(d) {
      var pts = parsePathPoints(d);
      pts.reverse();
      return pointsToPath(pts);
    }

    function spawnWalker(kind, opts) {
      if (!walkersLayer || !vendors.length) return null;
      opts = opts || {};
      var isDot = kind === "dot";
      var isCustom = kind === "custom";
      var g = el("g", {
        class:
          "lov-fp-walker-group" +
          (isDot ? " lov-fp-dot-walker" : isCustom ? " lov-fp-custom-walker" : " lov-fp-mascot-walker"),
        "aria-label": isDot ? "Dot walker" : isCustom ? opts.label || "Custom walker" : "Mascot walker",
      });

      var visual;
      if (isDot) {
        visual = el("circle", { class: "lov-fp-dot-walker-dot", r: 8, cx: 0, cy: 0, fill: "#000000", stroke: "none" });
      } else {
        var size = isCustom ? opts.size || MASCOT_SIZE : MASCOT_SIZE;
        visual = el("image", {
          href: isCustom ? opts.imageUrl || MASCOT_URL : MASCOT_URL,
          x: -size / 2,
          y: -size / 2,
          width: size,
          height: size,
        });
      }

      var bob = el("animateTransform", {
        attributeName: "transform",
        type: "translate",
        values: isDot ? "0 0; 0 -3; 0 0" : "0 0; 0 -5; 0 0",
        dur: isDot ? "0.35s" : "0.5s",
        repeatCount: "indefinite",
      });
      visual.appendChild(bob);
      g.appendChild(visual);
      walkersLayer.appendChild(g);

      var stopped = false;
      g.__stopWalker = function () {
        stopped = true;
      };

      function findTarget() {
        var key = opts.id != null ? opts.id : opts.boothId;
        if (key != null) {
          var keyStr = String(key);
          for (var i = 0; i < vendors.length; i++) {
            if (String(vendors[i].id) === keyStr) return vendors[i];
            if (vendors[i].booth != null && String(vendors[i].booth) === keyStr) return vendors[i];
          }
          console.warn("[floor-plan] addWalker: no vendor found for id", keyStr);
        }
        return vendors[Math.floor(Math.random() * vendors.length)];
      }

      function walkCycle() {
        if (stopped || !g.parentNode || !vendors.length) return;
        var v = findTarget();
        var oneWay = computePath(vendors, v);
        if (!oneWay) {
          setTimeout(walkCycle, 1000);
          return;
        }
        var back = reversePathString(oneWay);
        // Half-trip duration; dots are smaller/faster than mascots.
        var halfDur = isDot ? (2.5 + Math.random() * 1.5) * 1.25 : (4 + Math.random() * 2) * 1.25;
        var holdAtTable = isCustom && opts.holdAtTable != null ? opts.holdAtTable : 1.2;
        var holdAtEntrance = isDot ? 0.8 : 1.2;

        // Clear previous motions
        var prev = g.querySelectorAll("animateMotion");
        for (var p = 0; p < prev.length; p++) g.removeChild(prev[p]);

        var motionOut = el("animateMotion", {
          dur: halfDur + "s",
          begin: "indefinite",
          repeatCount: "1",
          rotate: "0",
          fill: "freeze",
          path: oneWay,
        });
        var motionBack = el("animateMotion", {
          dur: halfDur + "s",
          begin: "indefinite",
          repeatCount: "1",
          rotate: "0",
          fill: "freeze",
          path: back,
        });
        g.appendChild(motionOut);
        g.appendChild(motionBack);
        try {
          motionOut.beginElement();
        } catch (e) {}
        // Schedule the return trip relative to "now" instead of an absolute
        // document timestamp — otherwise the second cycle's begin time is in
        // the past and the walker never returns to the entrance.
        try {
          motionBack.beginElementAt(halfDur + holdAtTable);
        } catch (e2) {}

        if (isCustom && opts.loop === false) return;
        // Total: out + hold@table + back + hold@entrance
        var total = halfDur * 2 + holdAtTable + holdAtEntrance;
        setTimeout(walkCycle, total * 1000);
      }
      walkCycle();
      return g;
    }

    function startWalkers() {
      if (walkerTimer) clearInterval(walkerTimer);
      // 3 mascot walkers + 4 black-dot walkers, all looping.
      var MASCOTS = 5;
      var DOTS = 4;
      for (var i = 0; i < MASCOTS; i++) {
        setTimeout(function () {
          spawnWalker("mascot");
        }, i * 1500);
      }
      for (var j = 0; j < DOTS; j++) {
        setTimeout(
          function () {
            spawnWalker("dot");
          },
          600 + j * 700,
        );
      }
      // Top-up in case rebuild() clears the layer.
      walkerTimer = setInterval(function () {
        if (!walkersLayer) return;
        var have = walkersLayer.childNodes.length;
        var want = MASCOTS + DOTS;
        while (have < want) {
          // Refill with dots first (cheaper); mascots replenish on next tick.
          spawnWalker(have < DOTS ? "dot" : "mascot");
          have++;
        }
      }, 4000);
    }

    function drawBooth(v) {
      var b = boothBox(v);
      var g = el("g", {
        class: "lov-fp-booth" + v.booth + " lov-fp-booth ",
        tabindex: "0",
        role: "button",
        "aria-label": "Booth " + v.booth + ": " + v.name,
      });
      g.dataset.id = v.id;
      var rect = el("rect", {
        class: "lov-fp-booth-bg",
        x: b.x,
        y: b.y,
        width: b.w,
        height: b.h,
        rx: 10,
        fill: "#ffffff",
        stroke: "#cbd5e1",
        "stroke-width": 1.5,
      });
      var label = el("text", {
        x: b.cx,
        y: b.cy - 4,
        "text-anchor": "middle",
        "font-size": 14,
        "font-weight": 600,
        fill: "#0f172a",
      });
      label.textContent = v.booth;
      var maxChars = Math.max(8, (v.w || 1) * 14);
      var sub = el("text", {
        x: b.cx,
        y: b.cy + 14,
        "text-anchor": "middle",
        "font-size": 10,
        fill: "#64748b",
      });
      sub.textContent = v.name.length > maxChars ? v.name.slice(0, maxChars - 1) + "…" : v.name;
      g.appendChild(rect);
      g.appendChild(label);
      g.appendChild(sub);

      if (editable) {
        var handle = el("rect", {
          class: "lov-fp-resize",
          x: b.x + b.w - 14,
          y: b.y + b.h - 14,
          width: 12,
          height: 12,
          rx: 2,
        });
        g.appendChild(handle);
        attachEditHandlers(g, v, rect, handle);
      } else {
        g.addEventListener("click", function () {
          select(v.id);
        });
        g.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            select(v.id);
          }
        });
        // Hover preview: mouse users get a peek at the vendor without
        // committing to a selection. Touch devices skip this and use tap.
        g.addEventListener("pointerenter", function (e) {
          if (e.pointerType === "touch") return;
          if (state.selected && state.selected.id === v.id) return;
          panel.classList.add("is-preview");
          renderVendor(panel, v);
        });
        g.addEventListener("pointerleave", function (e) {
          if (e.pointerType === "touch") return;
          panel.classList.remove("is-preview");
          if (state.selected) renderVendor(panel, state.selected);
          else renderEntrance(panel);
        });
      }
      svg.appendChild(g);
      boothNodes[v.id] = g;
    }

    function svgPoint(e) {
      var pt = svg.createSVGPoint();
      pt.x = e.clientX;
      pt.y = e.clientY;
      var ctm = svg.getScreenCTM();
      if (!ctm) return { x: 0, y: 0 };
      var p = pt.matrixTransform(ctm.inverse());
      return { x: p.x, y: p.y };
    }
    function pointToCell(p) {
      var col = Math.floor((p.x - PAD) / CELL) + 1;
      var row = Math.floor((p.y - PAD) / CELL) + 1;
      return { col: col, row: row };
    }
    function overlaps(v, col, row, w, h) {
      for (var i = 0; i < vendors.length; i++) {
        var o = vendors[i];
        if (o.id === v.id) continue;
        var ow = Math.max(1, o.w || 1),
          oh = Math.max(1, o.h || 1);
        if (col < o.col + ow && col + w > o.col && row < o.row + oh && row + h > o.row) return true;
      }
      return false;
    }
    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    function attachEditHandlers(g, v, rect, handle) {
      // Two-phase pointer model: pressing a booth "arms" a potential drag but
      // does not move anything until the pointer travels past DRAG_THRESHOLD
      // pixels. A pointerup before that threshold is treated as a click and
      // simply selects the booth — so it's easy to pick one without
      // accidentally dragging every booth you hover over.
      var DRAG_THRESHOLD = 5;
      var armed = false,
        dragging = false,
        mode = null,
        startPt = null,
        startClient = null,
        origin = null,
        pointerId = null;

      function onDown(e, m) {
        e.preventDefault();
        e.stopPropagation();
        armed = true;
        dragging = false;
        mode = m;
        startPt = svgPoint(e);
        startClient = { x: e.clientX, y: e.clientY };
        origin = { col: v.col, row: v.row, w: v.w || 1, h: v.h || 1 };
        pointerId = e.pointerId;
        // Resize handle always drags immediately — there's nothing to "click".
        if (m === "resize") beginDrag(e);
      }
      function beginDrag(e) {
        dragging = true;
        g.classList.add("is-dragging");
        try {
          g.setPointerCapture(e.pointerId);
        } catch (_) {}
      }
      function onMove(e) {
        if (!armed) return;
        if (!dragging) {
          var dx = e.clientX - startClient.x;
          var dy = e.clientY - startClient.y;
          if (dx * dx + dy * dy < DRAG_THRESHOLD * DRAG_THRESHOLD) return;
          beginDrag(e);
        }
        var p = svgPoint(e);
        var dCol = Math.round((p.x - startPt.x) / CELL);
        var dRow = Math.round((p.y - startPt.y) / CELL);
        if (mode === "move") {
          var nc = clamp(origin.col + dCol, 1, COLS - origin.w + 1);
          var nr = clamp(origin.row + dRow, 1, ROWS - origin.h + 1);
          if (!overlaps(v, nc, nr, origin.w, origin.h)) {
            v.col = nc;
            v.row = nr;
          }
        } else {
          var nw = clamp(origin.w + dCol, 1, COLS - v.col + 1);
          var nh = clamp(origin.h + dRow, 1, ROWS - v.row + 1);
          if (!overlaps(v, v.col, v.row, nw, nh)) {
            v.w = nw;
            v.h = nh;
          }
        }
        updateBoothGeom();
        if (statusEl)
          statusEl.textContent = v.booth + " — col " + v.col + ", row " + v.row + ", " + (v.w || 1) + "x" + (v.h || 1);
      }
      function onUp(e) {
        if (!armed) return;
        var wasDragging = dragging;
        armed = false;
        dragging = false;
        mode = null;
        g.classList.remove("is-dragging");
        try {
          if (pointerId != null) g.releasePointerCapture(pointerId);
        } catch (_) {}
        pointerId = null;
        // Click (no drag) → select this booth so Remove and the side panel
        // can act on it.
        if (!wasDragging) {
          select(v.id);
          // Refresh selected highlight + path immediately.
          if (statusEl) statusEl.textContent = "Selected " + (v.booth || v.id) + ".";
        }
      }
      function updateBoothGeom() {
        var b = boothBox(v);
        rect.setAttribute("x", b.x);
        rect.setAttribute("y", b.y);
        rect.setAttribute("width", b.w);
        rect.setAttribute("height", b.h);
        var texts = g.querySelectorAll("text");
        if (texts[0]) {
          texts[0].setAttribute("x", b.cx);
          texts[0].setAttribute("y", b.cy - 4);
        }
        if (texts[1]) {
          texts[1].setAttribute("x", b.cx);
          texts[1].setAttribute("y", b.cy + 14);
        }
        handle.setAttribute("x", b.x + b.w - 14);
        handle.setAttribute("y", b.y + b.h - 14);
      }

      rect.addEventListener("pointerdown", function (e) {
        onDown(e, "move");
      });
      handle.addEventListener("pointerdown", function (e) {
        onDown(e, "resize");
      });
      g.addEventListener("pointermove", onMove);
      g.addEventListener("pointerup", onUp);
      g.addEventListener("pointercancel", onUp);
    }

    function select(id) {
      var v = null;
      for (var i = 0; i < vendors.length; i++)
        if (vendors[i].id === id) {
          v = vendors[i];
          break;
        }
      state.selected = v;
      for (var bid in boothNodes) boothNodes[bid].classList.toggle("is-selected", bid === id);
      var d = computePath(vendors, v);
      if (d) routePath.setAttribute("d", d);
      else routePath.removeAttribute("d");
      if (v) renderVendor(panel, v);
      else renderEmpty(panel);
      // Dispatch a scoped event on this container so multiple floor plans on the
      // same page stay isolated. Hosts (e.g. the Shopify Liquid pill) should
      // listen on their own <div data-floor-plan> element, not on document.
      try {
        node.dispatchEvent(
          new CustomEvent("lov-fp:select", {
            detail: {
              booth: v ? v.booth || v.id : null,
              id: v ? v.id : null,
              name: v ? v.name : null,
              vendor: v || null,
            },
            bubbles: true,
          }),
        );
      } catch (_) {}
    }

    function showEntrance() {
      state.selected = null;
      for (var bid in boothNodes) boothNodes[bid].classList.remove("is-selected");
      if (routePath) routePath.removeAttribute("d");
      renderEntrance(panel);
    }

    function showExport(list) {
      var overlay = html("div", { class: "lov-fp-export" });
      var card = html("div", { class: "lov-fp-export-card" });
      card.appendChild(html("h3", null, "Vendor layout JSON"));
      card.appendChild(
        html(
          "p",
          { style: "margin:0;color:#64748b;font-size:13px" },
          "Copy this and paste into your <div data-vendors='...'> on Shopify.",
        ),
      );
      var ta = html("textarea");
      ta.value = JSON.stringify(list, null, 2);
      card.appendChild(ta);
      var row = html("div", { class: "lov-fp-row" });
      var copy = html("button");
      copy.textContent = "Copy";
      copy.className = "";
      copy.style.cssText = "background:#2563eb;color:#fff;border:0;border-radius:6px;padding:8px 14px;cursor:pointer";
      var close = html("button");
      close.textContent = "Close";
      close.style.cssText =
        "background:#fff;color:#0f172a;border:1px solid #cbd5e1;border-radius:6px;padding:8px 14px;cursor:pointer";
      copy.addEventListener("click", function () {
        ta.select();
        try {
          navigator.clipboard.writeText(ta.value);
          copy.textContent = "Copied!";
          setTimeout(function () {
            copy.textContent = "Copy";
          }, 1500);
        } catch (_) {
          document.execCommand("copy");
        }
      });
      close.addEventListener("click", function () {
        document.body.removeChild(overlay);
      });
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) document.body.removeChild(overlay);
      });
      row.appendChild(copy);
      row.appendChild(close);
      card.appendChild(row);
      overlay.appendChild(card);
      document.body.appendChild(overlay);
      ta.focus();
      ta.select();
    }

    rebuild();

    // Deep-link: auto-select booth from ?booth=<id|number> or #booth=<id|number>
    // Reliable across: initial load, full refresh, browser back/forward, and iOS bfcache restore.
    function readBoothParam() {
      try {
        // 1. Query string on current URL
        var q = new URLSearchParams(window.location.search || "");
        var v = q.get("booth");
        if (v) return v;
        // 2. Hash variants: #booth=X or #?booth=X or just #X after a "booth" marker
        var h = (window.location.hash || "").replace(/^#/, "");
        if (!h) {
          // 3. Fallback: container-level data attr (set by Shopify Custom Liquid snippet
          //    when parent strips query params).
          var dl = container.getAttribute("data-deep-link") || container.getAttribute("data-booth");
          if (dl) return dl;
          return null;
        }
        if (h.indexOf("booth=") === 0) return decodeURIComponent(h.slice(6));
        try {
          var hq = new URLSearchParams(h.replace(/^\?/, ""));
          var hv = hq.get("booth");
          if (hv) return hv;
        } catch (_) {}
        return null;
      } catch (_) {
        return null;
      }
    }
    function findVendor(key) {
      if (key == null) return null;
      var k = String(key).trim().toLowerCase();
      if (!k) return null;
      for (var i = 0; i < vendors.length; i++) {
        var v = vendors[i];
        if (String(v.id).toLowerCase() === k || String(v.booth).toLowerCase() === k) return v;
      }
      return null;
    }
    function scrollBoothIntoView(node) {
      if (!node) return;
      try {
        // Scroll the map's own scroll container (overflow:auto) so we don't yank the page.
        if (mapWrap && (mapWrap.scrollWidth > mapWrap.clientWidth || mapWrap.scrollHeight > mapWrap.clientHeight)) {
          var nRect = node.getBoundingClientRect();
          var mRect = mapWrap.getBoundingClientRect();
          var dx = nRect.left + nRect.width / 2 - (mRect.left + mRect.width / 2);
          var dy = nRect.top + nRect.height / 2 - (mRect.top + mRect.height / 2);
          mapWrap.scrollBy({ left: dx, top: dy, behavior: "smooth" });
        }
        // Also scroll the page so the widget is in view on mobile.
        if (node.scrollIntoView) {
          node.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
      } catch (_) {}
    }
    var _lastDeepKey = null;
    function applyDeepLink(force) {
      var key = readBoothParam();
      if (!force && key === _lastDeepKey) return;
      _lastDeepKey = key;
      var v = findVendor(key);
      if (v) {
        select(v.id);
        // Defer scroll until after layout/paint so SVG has real dimensions.
        var node = boothNodes[v.id];
        if (typeof requestAnimationFrame === "function") {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              scrollBoothIntoView(node);
            });
          });
        } else {
          setTimeout(function () {
            scrollBoothIntoView(node);
          }, 60);
        }
      } else if (key == null && state.selected) {
        // Back-nav to a URL without ?booth → clear selection
        select(null);
      }
    }
    // Run now, again after layout, and after full load — covers script-in-head,
    // late-mounting Shopify sections, and image-driven layout shifts.
    applyDeepLink(true);
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(function () {
        applyDeepLink(true);
      });
    }
    if (document.readyState !== "complete") {
      window.addEventListener(
        "load",
        function () {
          applyDeepLink(true);
        },
        { once: true },
      );
    }
    window.addEventListener("popstate", function () {
      applyDeepLink(true);
    });
    window.addEventListener("hashchange", function () {
      applyDeepLink(true);
    });
    // iOS Safari restores the page from bfcache without firing popstate.
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) applyDeepLink(true);
    });
    // Watch container data attrs in case a host script sets them after mount.
    if (typeof MutationObserver === "function") {
      try {
        new MutationObserver(function () {
          applyDeepLink(false);
        }).observe(container, { attributes: true, attributeFilter: ["data-deep-link", "data-booth"] });
      } catch (_) {}
    }
  }

  function renderEntrance(panel) {
    panel.innerHTML = "";
    panel.appendChild(html("div", { class: "lov-fp-meta" }, "Main Entrance · Hall B"));
    panel.appendChild(html("h3", null, "Welcome to the show"));
    panel.appendChild(
      html(
        "p",
        null,
        "The main entrance is on the south side of Hall B. From here you can walk the central aisle to reach any booth. Tap a table on the map for turn-by-turn directions from this spot.",
      ),
    );
    var box = html("div", {
      style: "margin-top:12px;padding:12px;border-radius:8px;background:#f1f5f9;font-size:13px;line-height:1.5",
    });
    box.appendChild(html("strong", null, "Getting around"));
    var ol = html("ol", { style: "margin:6px 0 0;padding-left:20px;color:#475569" });
    ol.appendChild(html("li", null, "Enter through the main doors at the south side of Hall B."));
    ol.appendChild(html("li", null, "Walk straight up the central aisle."));
    ol.appendChild(html("li", null, "Tap any booth on the map to see its location and route."));
    box.appendChild(ol);
    panel.appendChild(box);
  }

  function renderEmpty(panel) {
    panel.innerHTML = "";
    panel.appendChild(
      html(
        "p",
        { class: "lov-fp-empty" },
        "Select a booth on the map to see vendor details and walking directions from the entrance.",
      ),
    );
  }
  function renderVendor(panel, v) {
    panel.innerHTML = "";
    panel.appendChild(html("div", { class: "lov-fp-meta" }, "Booth " + v.booth + " · ")); //+ v.category
    var logoSrc =
      v.logo ||
      v.logoUrl ||
      v.logo_url ||
      "https://cdn.shopify.com/s/files/1/0016/8892/8354/files/roytato-potato.png?v=1781241271";
    var logoWrap = html("div", { class: "lov-fp-logo" });
    panel.appendChild(html("h3", null, v.name));
    logoWrap.appendChild(html("img", { src: logoSrc, alt: v.name + " logo", loading: "lazy" }));
    panel.appendChild(logoWrap);
    panel.appendChild(html("p", null, v.description));
     panel.appendChild(html("p", null, v.description2));


    if (v.website) {
      var p = html("p");
      var a = html(
        "a",
        { href: /^https?:/.test(v.website) ? v.website : "https://" + v.website, target: "_blank", rel: "noopener" },
        v.website,
      );
      p.appendChild(a);
      panel.appendChild(p);
    }
    // Share / QR
    try {
      var boothKey = encodeURIComponent(v.id);
      var shareUrl = window.location.origin + window.location.pathname + "?booth=" + boothKey + "#booth=" + boothKey;
      var wrap = html("div", { class: "lov-fp-share" });
      var qrSrc =
        "https://api.qrserver.com/v1/create-qr-code/?size=192x192&margin=1&data=" + encodeURIComponent(shareUrl);
      wrap.appendChild(html("img", { src: qrSrc, alt: "QR code for " + v.name, loading: "lazy" }));
      var body = html("div", { class: "lov-fp-share-body" });
      body.appendChild(html("strong", null, "Share this booth"));
      body.appendChild(html("a", { class: "lov-fp-share-link", href: shareUrl }, shareUrl));
      var btn = html("button", { class: "lov-fp-share-btn", type: "button" }, "Copy link");
      btn.addEventListener("click", function () {
        try {
          navigator.clipboard.writeText(shareUrl);
          btn.textContent = "Copied!";
          setTimeout(function () {
            btn.textContent = "Copy link";
          }, 1800);
        } catch (_) {
          window.prompt("Copy this link", shareUrl);
        }
      });
      body.appendChild(btn);
      wrap.appendChild(body);
      panel.appendChild(wrap);
      /* Buy this table pill
      var buyWrap = html("div", { class: "lov-fp-buy" });
      var buyBody = html("div", { class: "lov-fp-buy-body" });
      buyBody.appendChild(html("strong", null, "Reserve this table"));
      buyBody.appendChild(document.createTextNode("Book booth " + (v.booth || v.id) + " for your brand."));
      buyWrap.appendChild(buyBody);
      var buyHref = v.buyUrl || v.buy_url || "/products/booth-reservation?booth=" + boothKey;
      var buyBtn = html(
        "a",
        { class: "lov-fp-buy-btn", href: buyHref, target: "_blank", rel: "noopener" },
        "Buy this table",
      );
      buyWrap.appendChild(buyBtn);
      panel.appendChild(buyWrap); */
    } catch (_) {}
  }

  function readConfig(node) {
    var raw = node.getAttribute("data-floor-plan");
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }
  function isEditable(node) {
    if (node.hasAttribute("data-editable")) return true;
    try {
      var qs = (window.location.search || "").toLowerCase();
      if (qs.indexOf("fp-edit=1") !== -1) return true;
    } catch (_) {}
    return false;
  }

  var KRAKEN_URL = "https://krakenpintrade.com/cdn/shop/files/kraken-logo-2026-black.png";

  function printFloorPlan(svg, opts) {
    if (!svg) return;
    var clone = svg.cloneNode(true);
    clone.removeAttribute("style");
    clone.removeAttribute("width");
    clone.removeAttribute("height");
    // preserveAspectRatio so the SVG scales to fit its container box.
    clone.setAttribute("preserveAspectRatio", "xMidYMid meet");
    var title = (opts && opts.title) || document.title || "Floor Plan";
    var w = window.open("", "_blank", "width=1024,height=768");
    if (!w) return;
    // Derive aspect ratio from viewBox so the SVG can be sized to fit one page
    // on any paper size / orientation (including mobile portrait printing).
    var vb = (clone.getAttribute("viewBox") || "0 0 1000 700").split(/\s+/);
    var vbW = parseFloat(vb[2]) || 1000;
    var vbH = parseFloat(vb[3]) || 700;
    var landscape = vbW >= vbH;
    var parts = [
      "<!doctype html>",
      "<html><head><meta charset='utf-8'>",
      "<meta name='viewport' content='width=device-width,initial-scale=1'>",
      "<title>" + title + "</title>",
      "<style>",
      // Match page orientation to the map so it always fits one page.
      "@page { size: " + (landscape ? "landscape" : "portrait") + "; margin: 6mm; }",
      "html,body{margin:0;padding:0;background:#fff;color:#000;font-family:system-ui,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact;}",
      "*{page-break-inside:avoid;break-inside:avoid;}",
      ".wrap{box-sizing:border-box;padding:4mm;display:flex;flex-direction:column;gap:4px;}",
      ".hdr{display:flex;align-items:center;gap:6px;flex:0 0 auto;}",
      ".hdr img{height:18px;width:auto;display:block;}",
      ".hdr h1{font-size:12px;margin:0;font-weight:600;}",
      ".svg-box{flex:0 0 auto;width:100%;display:flex;align-items:center;justify-content:center;}",
      // Size SVG by aspect ratio so it never overflows the printable area.
      ".svg-box svg{display:block;width:100%;height:auto;max-width:100%;aspect-ratio:" + vbW + " / " + vbH + ";}",
      "@media screen {",
      "  .wrap{min-height:100vh;}",
      "}",
      "@media print {",
      "  html,body,.wrap{width:100%;height:100%;overflow:hidden;}",
      "  .wrap{height:100vh;page-break-after:avoid;break-after:avoid;}",
      // Constrain SVG to fit within one page in both dimensions.
      "  .svg-box{flex:1 1 auto;min-height:0;height:100%;}",
      "  .svg-box svg{width:auto;height:auto;max-width:100%;max-height:100%;}",
      "}",
      "</style>",
      "</head><body><div class='wrap'>",
      "<div class='hdr'><img src='" + KRAKEN_URL + "' alt='Logo'/><h1>" + title + "</h1></div>",
      "<div class='svg-box'>" + clone.outerHTML + "</div>",
      "</div></body></html>",
    ];

    w.document.open();
    w.document.write(parts.join(""));
    w.document.close();
    w.focus();
    var img = w.document.querySelector(".hdr img");
    function go() {
      setTimeout(function () {
        w.print();
      }, 200);
    }
    if (img && !img.complete) {
      img.addEventListener("load", go);
      img.addEventListener("error", go);
    } else {
      go();
    }
  }

  function storageKeyFor(node) {
    return node.getAttribute("data-storage-key") || "lov-fp:vendors:" + (node.id || "default");
  }

  function loadSaved(node) {
    try {
      var raw = localStorage.getItem(storageKeyFor(node));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (_) {}
    return null;
  }

  function mount(node) {
    if (node.__lovFpMounted) return;
    node.__lovFpMounted = true;
    var cfg = readConfig(node);
    var editable = isEditable(node);
    var storageKey = storageKeyFor(node);

    function go(list) {
      var copy = list.map(function (v) {
        return Object.assign({}, v);
      });
      var initial = list.map(function (v) {
        return Object.assign({}, v);
      });
      render(node, copy, { editable: editable, initial: initial, storageKey: storageKey });
    }

    // 1. Saved layout from localStorage takes priority so user edits persist.
    var saved = loadSaved(node);
    if (saved) {
      go(saved);
      return;
    }

    var inlineRaw = node.getAttribute("data-vendors");
    if (inlineRaw) {
      try {
        var parsed = JSON.parse(inlineRaw);
        if (Array.isArray(parsed) && parsed.length) {
          go(parsed);
          return;
        }
      } catch (e) {
        console.warn("[floor-plan] invalid data-vendors JSON:", e);
      }
    }

    var tag = node.querySelector('script[type="application/json"]');
    if (tag) {
      try {
        var parsed2 = JSON.parse(tag.textContent || "[]");
        if (Array.isArray(parsed2) && parsed2.length) {
          go(parsed2);
          return;
        }
      } catch (e) {
        console.warn("[floor-plan] invalid inline <script> JSON:", e);
      }
    }

    if (cfg.vendorsUrl) {
      fetch(cfg.vendorsUrl)
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          go(Array.isArray(data) && data.length ? data : DEFAULT_VENDORS);
        })
        .catch(function () {
          go(DEFAULT_VENDORS);
        });
      return;
    }

    go(DEFAULT_VENDORS);
  }

  function init() {
    ensureStyles();
    var nodes = document.querySelectorAll("[data-floor-plan]");
    for (var i = 0; i < nodes.length; i++) mount(nodes[i]);
  }

  // Expose a small global so host pages (e.g. our React route) can re-init
  // after mounting a container dynamically.
  function addWalker(opts, container) {
    container = container || document.querySelector("[data-floor-plan]");
    if (!container) return null;
    var tries = 0;
    function attempt() {
      if (container.__lovFpAddWalker) return container.__lovFpAddWalker(opts);
      if (tries++ < 40) return setTimeout(attempt, 100);
      console.warn("[floor-plan] addWalker: container not ready");
    }
    return attempt();
  }
  window.LovableFloorPlan = { init: init, mount: mount, addWalker: addWalker };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
